define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaTypeDomain = void 0;
    class WaTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaTypeDomain.StockRouteFacility, value: "Stock Route Facility" },
                    { key: WaTypeDomain.Supply, value: "Supply" },
                    { key: WaTypeDomain.Access, value: "Access" },
                    { key: WaTypeDomain.Special, value: "Special" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaTypeDomain.StockRouteFacility] = 0;
                this.KeyIndex[WaTypeDomain.Supply] = 1;
                this.KeyIndex[WaTypeDomain.Access] = 2;
                this.KeyIndex[WaTypeDomain.Special] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Stock Route Facility"] = 0;
                this.ValueIndex["Supply"] = 1;
                this.ValueIndex["Access"] = 2;
                this.ValueIndex["Special"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaTypeDomain = WaTypeDomain;
    Object.defineProperty(WaTypeDomain, "StockRouteFacility", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaTypeDomain, "Supply", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaTypeDomain, "Access", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaTypeDomain, "Special", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
